module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'comment-main': true, 'fix': _vm.showProductStatus
    }
  }, [(_vm.loading) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('title-component', {
    attrs: {
      "dealName": _vm.dealName
    },
    on: {
      "showProductTc": function($event) {
        _vm.changeProductTc(true)
      }
    }
  }), _vm._v(" "), _c('filter-component', {
    attrs: {
      "did": _vm.did
    }
  }), _vm._v(" "), _c('list-component', {
    attrs: {
      "did": _vm.did
    },
    on: {
      "changeLoading": _vm.changeLoading
    }
  }), _vm._v(" "), (_vm.showProductStatus) ? _c('product-component', {
    attrs: {
      "did": _vm.did,
      "businessType": _vm.businessType,
      "businessTypeName": _vm.businessTypeName
    },
    on: {
      "closeProductTc": function($event) {
        _vm.changeProductTc(false)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbeb821a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/comment/list/Main.vue
// module id = 730
// module chunks = 0